import { formatAsMoney, formatDate } from '@perch-labs/warbler';
import { copyFor } from 'config';
import { lineItemKeys } from 'domain/statement';

const getCopy = copyFor('solar.personalEnergyProduction');

interface LineItem {
  key: string;
  vnmSavingsCents?: number | null;
}

export const getSolarCredit = (lineItems: LineItem[]) => {
  const solarCreditLineItem = lineItems.find(
    lineItem => lineItem.key === lineItemKeys.vnmSolarCharge
  );
  const solarCredit = solarCreditLineItem?.vnmSavingsCents;
  return solarCredit
    ? formatAsMoney(solarCredit, { conversion: 'fromCents' })
    : undefined;
};

interface PersonalEnergyProductionCopy {
  body: string;
  emptyPlaceholder: string;
  kwhLabel: string;
  solarCreditsLabel: string;
  title: string;
  allocation: {
    size: string;
    label: string;
    tooltip: { copy: string; label: string };
  };
}

interface CopyParams {
  credit?: string | null;
  endDate: Date;
  startDate: Date;
  calculatedAllocationKw?: number | null;
}

export const getPersonalEnergyProductionCopy = (
  params: CopyParams
): PersonalEnergyProductionCopy => {
  const formattedEndDate = formatDate(params.endDate, { format: 'MMM d' });
  const formattedStartDate = formatDate(params.startDate, { format: 'MMM d' });

  const personalEnergyProductionCopy = getCopy('enrolled');
  personalEnergyProductionCopy.body = params.credit
    ? getCopy('enrolled.body', {
        endDate: formattedEndDate,
        startDate: formattedStartDate,
      })
    : getCopy('enrolled.bodyWithoutCredits', {
        endDate: formattedEndDate,
        startDate: formattedStartDate,
      });
  const { calculatedAllocationKw } = params;
  personalEnergyProductionCopy.allocation.size = calculatedAllocationKw
    ? getCopy('enrolled.allocation.size', {
        calculatedAllocationKw: Math.round(calculatedAllocationKw),
      })
    : getCopy('enrolled.emptyPlaceholder');
  return personalEnergyProductionCopy;
};
